import Phaser from 'phaser';
import { createGameConfig, getInitialSceneKey } from './game/gameConfig';
import { PadScene } from './scenes/PadScene';
import { LaunchScene } from './scenes/LaunchScene';
import { FlightScene } from './scenes/FlightScene';
import { MoonScene } from './scenes/MoonScene';
import { DrillScene } from './scenes/DrillScene';
import { WinScene } from './scenes/WinScene';

class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create() {
    this.scene.start(getInitialSceneKey());
  }
}

const game = new Phaser.Game(
  createGameConfig([
    BootScene,
    PadScene,
    LaunchScene,
    FlightScene,
    MoonScene,
    DrillScene,
    WinScene,
  ]),
);

(globalThis as typeof globalThis & { __lunaGame?: Phaser.Game }).__lunaGame = game;

void game;
